import React from 'react';
import SMFormFieldBaseView from 'components/dashboard/form/SMFormFieldBaseView';

class SMFormTextArea extends SMFormFieldBaseView {
  
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.name,
      value : this.props.value ? this.props.value : "",
    };
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.value != this.props.value) {
      this.setState({
        value : nextProps.value,
      });
    }
  }
  
  didFocus(e) {
  }
  
  didBlur(e) {
    if (this.isChange) {
      if(this.props.delegate && typeof this.props.delegate.textAreaDidEndEditing === 'function'){
        this.props.delegate.textAreaDidEndEditing(e);
      }
    }
    this.isChange = false;
  }
  
  didChangeValue(e) {
    this.isChange = true;
    this.setState({ value: e.currentTarget.value });
  }

  render() {
    
    const fieldClassName = this.errorFieldClassName(this.props.options.className, this.props.errorText);
    
    return (
      <textarea type="text" 
        name={this.state.name} 
        value={this.state.value} 
        className={fieldClassName} 
        disabled={this.props.options.disabled}
        placeholder={this.props.placeholderText}
        onChange={this.didChangeValue.bind(this)} 
        onFocus={this.didFocus.bind(this)} 
        onBlur={this.didBlur.bind(this)} />
    );
  }
}

SMFormTextArea.defaultProps = {
  options: {
    className: 'form-textarea w500 h80',
    disabled: false
  }
};
export default SMFormTextArea;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormTextArea.jsx